<template>
  <b-card>
    <div>
      <span
        class="font-weight-bold"
        style="font-size: 24px;"
      >ประเภทงาน</span>
    </div>
    <b-row>
      <b-col
        lg="4"
        md="4"
        class="d-flex align-items-center justify-content-start mb-1 mt-1"
      >
        <label>ค้นหา</label>
        <b-input-group
          size="sm"
          style="padding-left:14px;"
        >
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="ป้อนคำค้นหา"
            label-cols-sm="12"
            label-cols-md="2"
            label-cols-lg="2"
            style=" background-color:rgba(0,0,0, 0.6);"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              ล้าง
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col
        cols="8"
        class="d-flex align-items-center justify-content-end mb-1"
      >
        <a>
          <b-button
            id="SolutionAdd"
            v-b-modal="'SolutionAdd'+modalID"
            variant="primary"
            class="btn-icon"
          >
            <feather-icon
              icon="PlusCircleIcon"
              size="24"
              class="mr-1"
            />
            <label style="color:white; font-size: 14px;">เพิ่มประเภทงาน</label>
          </b-button>
        </a>
      </b-col>
      <b-col
        cols="12"
        class="mb-1"
      >
        <b-table
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(anydesk)="data">
            <a
              v-if="data.item.anydesk"
              :href="'anydesk:'+data.item.anydesk"
            >
              <b-button
                size="sm"
                variant="outline-danger"
              ><b-img
                src="@/assets/images/logo/anydesk.png"
                style="height: 16px; width: 16px;"
              /> <span style="color:#fff;"> {{ data.item.anydesk }}</span></b-button>
            </a>
          </template>
          <template #cell(cam)="data">
            <b-link
              v-if="data.item.type_name !== 'CCTV'"
              v-b-modal="'SelectCam'+ modalID"
              @click="$refs.selectCam.getSumEquipment(data.item.id, data.item.type_name)"
            ><feather-icon
              icon="PlusCircleIcon"
              size="24"
              class="mr-1"
            />{{ data.value }}
            </b-link>
          </template>
          <template #cell(License)="data">
            <b-button
              v-b-modal="'modalCrossing'+ modalID"
              title="กดเพื่อดูเพิ่มเติม"
              size="sm"
              variant="outline"
              @click="$refs.pid1.getLicense(data.item.type_name)"
            >
              <b-img
                src="@/assets/images/icons/key.png"
                style="height: 18px; width: 18px;"
              />
            </b-button>
          </template>
          <template #cell(link)="data">
            <b-link
              v-if="data.item.type_name === 'CCTV'"
              :to="{ path: `/cctv-detail?wid=${data.item.id}`}"
              target="_blank"
              size="sm"
              variant="outline"
              style="text-decoration: underline; color: #11DF00;"
            >
              {{ data.item.detail }}
              <feather-icon
                icon="ChevronRightIcon"
                size="24"
              />
            </b-link>
            <b-link
              v-if="data.item.type_name === 'Counting7'"
              :to="{ path: `/counting-sci-fi?wid=${data.item.id}`}"
              target="_blank"
              size="sm"
              variant="outline"
              style="text-decoration: underline; color: #11DF00;"
            >
              {{ data.item.detail }}
              <feather-icon
                icon="ChevronRightIcon"
                size="24"
              />
            </b-link>
            <b-link
              v-if="data.item.type_name === 'Analytic'"
              :to="{ path: `/analytic-sci-fi?wid=${data.item.id}&analytic_type=${data.item.analytic_type}`}"
              target="_blank"
              size="sm"
              variant="outline"
              style="text-decoration: underline; color: #11DF00;"
            >
              {{ data.item.detail }}
              <feather-icon
                icon="ChevronRightIcon"
                size="24"
              />
            </b-link>
            <b-link
              v-if="data.item.type_name === 'Traffic'"
              :to="{ path: `/traffic-sci-fi?wid=${data.item.id}`}"
              target="_blank"
              size="sm"
              variant="outline"
              style="text-decoration: underline; color: #11DF00;"
            >
              {{ data.item.detail }}
              <feather-icon
                icon="ChevronRightIcon"
                size="24"
              />
            </b-link>
          </template>
        </b-table>
      </b-col>
      <b-col
        cols="12"
      >
        <b-card-body class="d-flex justify-content-between flex-wrap pt-1">
          <!-- page length -->
          <b-form-group
            label="Per Page"
            label-cols="6"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
            />
          </b-form-group>

          <!-- pagination -->
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-col>
      <SumSolutionAdd
        :id-data="modalID"
        :data="optionsLocal"
        @fetch="getSumSolution(optionsLocal.location_id)"
      />
      <SelectSolution
        ref="childref"
        :id-data="modalID"
      />
      <ModalSelectCam
        ref="selectCam"
        :id-data="modalID"
      />
      <modal-Crossing
        ref="pid1"
        :id-data="modalID"
      />
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BTable, BPagination, BFormGroup, BFormSelect, BCardBody,
  BInputGroup, BInputGroupAppend, BFormInput, BButton, BImg, BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import SumSolutionAdd from './SumSolutionAdd.vue'
import ModalSelectCam from './ModalSelectCam.vue'
import SelectSolution from './SelectSolution.vue'
import ModalCrossing from './modalCrossing.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BButton,
    BImg,
    BLink,
    SumSolutionAdd,
    SelectSolution,
    ModalSelectCam,
    ModalCrossing,
  },
  directives: {
    Ripple,
  },
  props: {
    projectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      optionsLocal: JSON.parse(JSON.stringify(this.projectData)),
      fields: [
        {
          key: 'type_name',
          label: 'ประเภทงาน',
          class: 'text-center',
        },
        {
          key: 'License',
          label: 'Info',
          class: 'text-center',
        },
        {
          key: 'cam',
          label: 'เลือกกล้อง',
          class: 'text-center',
        },
        {
          key: 'link',
          label: 'ไปยังหน้าเว็บ',
          class: 'text-center',
        },
      ],
      items: [],
      perPage: 50,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      modalID: 0,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getSumSolution(this.optionsLocal.location_id)
  },
  methods: {
    getSumSolution(id) {
      this.modalID = this.optionsLocal.location_id
      axios
        .post('/tableSolution', { pj_code: this.$route.query.pj_code, location_id: id })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
